(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mainspring-calculator"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function initMainspringCalculator(root) {
      if (!root || root.dataset.ready === "true") return;
      if (!root.querySelector("[data-svg-top]")) return;
      root.dataset.ready = "true";

      var state = {
        mode: "calculate",
        view: "top",
        result: null,
        dragging: null,
        dragStartX: 0,
        dragStartValue: 0
      };

      var typeLabels = {
        manual: "Manual wind",
        auto: "Automatic",
        pocket: "Pocket watch",
        clock: "Clock / large movement"
      };

      var q = function (selector) { return root.querySelector(selector); };
      var qa = function (selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); };
      var input = function (name) { return q('[data-input="' + name + '"]'); };
      var range = function (name) { return q('[data-range="' + name + '"]'); };
      var numberValue = function (name) {
        var field = input(name);
        return field ? parseFloat(field.value) || 0 : 0;
      };
      var textValue = function (name) {
        var field = input(name);
        return field ? field.value.trim() : "";
      };
      var fmt = function (value, places) { return Number(value || 0).toFixed(places); };

      function initDefaults() {
        input("watchType").value = root.dataset.defaultType || "manual";
        input("powerReserve").value = root.dataset.defaultReserve || 40;
        input("material").value = root.dataset.defaultMaterial || "white";
        if (!input("barrelDia").value) input("barrelDia").value = "12.00";
        if (!input("arborDia").value) input("arborDia").value = "2.80";
        setView(state.view || "top");
        updateDiagram();
      }

      function syncRangeControls() {
        var barrelDia = numberValue("barrelDia") || 12;
        var arborDia = numberValue("arborDia") || 2.8;
        var barrelRange = range("barrelDia");
        var arborRange = range("arborDia");
        var barrelReadout = q('[data-range-value="barrelDia"]');
        var arborReadout = q('[data-range-value="arborDia"]');

        if (barrelRange) barrelRange.value = Math.max(4, Math.min(30, barrelDia)).toFixed(2);
        if (arborRange) {
          arborRange.max = Math.max(0.5, Math.min(15, barrelDia - 0.5)).toFixed(2);
          arborRange.value = Math.max(0.5, Math.min(parseFloat(arborRange.max), arborDia)).toFixed(2);
        }
        if (barrelReadout) barrelReadout.textContent = fmt(barrelDia, 2) + " mm";
        if (arborReadout) arborReadout.textContent = fmt(arborDia, 2) + " mm";
      }

      function clearErrors() {
        qa(".rr-ms__field.is-error").forEach(function (field) { field.classList.remove("is-error"); });
        qa("[data-error]").forEach(function (field) { field.textContent = ""; });
      }

      function setError(name, message) {
        var field = q('[data-field="' + name + '"]');
        var error = q('[data-error="' + name + '"]');
        if (field) field.classList.add("is-error");
        if (error) error.textContent = message;
      }

      function validate() {
        clearErrors();
        var valid = true;
        var barrelDia = numberValue("barrelDia");
        var barrelDepth = numberValue("barrelDepth");
        var arborDia = numberValue("arborDia");

        if (barrelDia <= 0) { setError("barrelDia", "Enter a positive barrel diameter."); valid = false; }
        if (barrelDepth <= 0) { setError("barrelDepth", "Enter a positive barrel depth."); valid = false; }
        if (arborDia <= 0) { setError("arborDia", "Enter a positive arbor diameter."); valid = false; }
        if (barrelDia > 0 && arborDia >= barrelDia) { setError("arborDia", "The arbor must be smaller than the barrel."); valid = false; }

        if (state.mode === "verify") {
          if (numberValue("knownHeight") <= 0) { setError("knownHeight", "Enter the measured spring height."); valid = false; }
          if (numberValue("knownThickness") <= 0) { setError("knownThickness", "Enter the measured spring thickness."); valid = false; }
          if (numberValue("knownLength") <= 0) { setError("knownLength", "Enter the measured spring length."); valid = false; }
        }

        return valid;
      }

      function thicknessRange(watchType, barrelDia) {
        if (watchType === "auto") return barrelDia < 10 ? [0.06, 0.08] : [0.08, 0.11];
        if (watchType === "pocket") return [0.12, 0.18];
        if (watchType === "clock") return [0.20, 0.45];
        return barrelDia < 10 ? [0.07, 0.09] : [0.09, 0.12];
      }

      function calculateRecommendation() {
        var barrelDia = numberValue("barrelDia");
        var barrelDepth = numberValue("barrelDepth");
        var arborDia = numberValue("arborDia");
        var watchType = input("watchType").value;
        var reserve = Math.max(1, numberValue("powerReserve") || 40);
        var material = input("material").value;
        var clearance = 0.15;
        var springHeight = Math.max(0, barrelDepth - clearance);
        var range = thicknessRange(watchType, barrelDia);
        var thickness = (range[0] + range[1]) / 2;
        var targetFill = watchType === "auto" ? 0.42 : 0.48;
        var outerRadius = (barrelDia / 2) - 0.25;
        var innerRadius = (arborDia / 2) + 0.25;
        var availableRadius = Math.max(0, outerRadius - innerRadius);
        var estimatedTurns = availableRadius > 0 ? (availableRadius * targetFill) / thickness : 0;
        var averageDiameter = (barrelDia + arborDia) / 2;
        var baseLength = estimatedTurns * Math.PI * averageDiameter;
        var reserveFactor = 1 + (0.7 * Math.log(reserve / 40));
        var adjustedLength = Math.max(0, Math.round(baseLength * Math.max(0.8, reserveFactor)));
        var fillRatio = availableRadius > 0 ? (estimatedTurns * thickness) / availableRadius * 100 : 0;

        return {
          mode: "calculate",
          title: "Recommended mainspring",
          caliber: textValue("caliberRef"),
          watchType: watchType,
          barrelDia: barrelDia,
          barrelDepth: barrelDepth,
          arborDia: arborDia,
          springHeight: springHeight,
          thickness: thickness,
          thicknessRange: range,
          length: adjustedLength,
          reserve: reserve,
          fillRatio: fillRatio,
          material: material === "white" ? "White alloy / Nivaflex style" : "Blue tempered carbon steel"
        };
      }

      function calculateVerification() {
        var barrelDia = numberValue("barrelDia");
        var barrelDepth = numberValue("barrelDepth");
        var arborDia = numberValue("arborDia");
        var springHeight = numberValue("knownHeight");
        var thickness = numberValue("knownThickness");
        var length = numberValue("knownLength");
        var outerCoilDiameter = barrelDia - 0.5;
        var innerCoilDiameter = arborDia + 0.5;
        var availableRadius = Math.max(0, (outerCoilDiameter - innerCoilDiameter) / 2);
        var averageCoilDiameter = Math.max(0.01, (outerCoilDiameter + innerCoilDiameter) / 2);
        var turns = length / (Math.PI * averageCoilDiameter);
        var fillRatio = availableRadius > 0 ? (turns * thickness) / availableRadius * 100 : 0;
        var clearance = barrelDepth - springHeight;

        return {
          mode: "verify",
          title: "Spring verification",
          caliber: textValue("caliberRef"),
          watchType: input("watchType").value,
          barrelDia: barrelDia,
          barrelDepth: barrelDepth,
          arborDia: arborDia,
          springHeight: springHeight,
          thickness: thickness,
          length: length,
          clearance: clearance,
          turns: turns,
          fillRatio: fillRatio
        };
      }

      function renderResults(result) {
        state.result = result;
        q("[data-results]").hidden = false;
        q("[data-results-title]").textContent = result.title;
        q("[data-summary]").innerHTML = [
          ["Caliber", result.caliber || "Not specified"],
          ["Type", typeLabels[result.watchType]],
          ["Barrel", fmt(result.barrelDia, 2) + " x " + fmt(result.barrelDepth, 2) + " mm"],
          ["Arbor", fmt(result.arborDia, 2) + " mm"]
        ].map(function (item) {
          return '<span class="rr-ms__pill"><strong>' + item[0] + ':</strong>&nbsp;' + item[1] + '</span>';
        }).join("");

        var cards = [];
        if (result.mode === "calculate") {
          cards = [
            ["Spring height", fmt(result.springHeight, 2), "mm, allowing 0.15 mm clearance", true],
            ["Thickness", fmt(result.thickness, 3), "mm, range " + result.thicknessRange[0].toFixed(2) + " - " + result.thicknessRange[1].toFixed(2), true],
            ["Length", Math.round(result.length), "mm, for about " + result.reserve + " hours", true],
            ["Fill ratio", Math.round(result.fillRatio) + "%", fillAdvice(result.fillRatio), false],
            ["Material", result.material, "Choose closest supplier equivalent", false],
            ["Arbor diameter", fmt(result.arborDia, 2), "mm", false]
          ];
        } else {
          cards = [
            ["Height clearance", fmt(result.clearance, 2), clearanceAdvice(result.clearance), true],
            ["Spring height", fmt(result.springHeight, 2), "mm", false],
            ["Thickness", fmt(result.thickness, 3), "mm", false],
            ["Length", Math.round(result.length), "mm", false],
            ["Estimated turns", fmt(result.turns, 1), "coils", false],
            ["Fill ratio", Math.round(result.fillRatio) + "%", fillAdvice(result.fillRatio), true]
          ];
        }

        q("[data-result-grid]").innerHTML = cards.map(function (card) {
          return '<div class="rr-ms__metric' + (card[3] ? ' is-primary' : '') + '">' +
            '<span class="rr-ms__mini-label">' + card[0] + '</span>' +
            '<span class="rr-ms__metric-value">' + card[1] + '</span>' +
            '<span class="rr-ms__metric-note">' + card[2] + '</span>' +
            '</div>';
        }).join("");

        updateDiagram();
        setShopLink(result);
        q("[data-results]").scrollIntoView({ behavior: "smooth", block: "nearest" });
      }

      function fillAdvice(fillRatio) {
        if (fillRatio >= 40 && fillRatio <= 58) return "Good practical fill";
        if (fillRatio > 58 && fillRatio <= 70) return "Tight, check carefully";
        if (fillRatio > 70) return "Likely overfilled";
        return "Loose, may underperform";
      }

      function clearanceAdvice(clearance) {
        if (clearance >= 0.08 && clearance <= 0.30) return "Good working clearance";
        if (clearance < 0.08) return "Too tight";
        return "Loose, check height";
      }

      function setMode(nextMode) {
        state.mode = nextMode;
        qa("[data-mode]").forEach(function (button) {
          button.setAttribute("aria-pressed", button.dataset.mode === nextMode ? "true" : "false");
        });
        q("[data-verify-fields]").hidden = nextMode !== "verify";
      }

      function setView(nextView) {
        state.view = nextView;
        qa("[data-view]").forEach(function (button) {
          button.setAttribute("aria-pressed", button.dataset.view === nextView ? "true" : "false");
        });
        var topSvg = q("[data-svg-top]");
        var sideSvg = q("[data-svg-side]");
        var showTop = nextView === "top";
        topSvg.classList.toggle("is-hidden", !showTop);
        sideSvg.classList.toggle("is-hidden", showTop);
        if (showTop) {
          topSvg.removeAttribute("hidden");
          sideSvg.setAttribute("hidden", "");
          topSvg.style.display = "block";
          sideSvg.style.display = "none";
        } else {
          sideSvg.removeAttribute("hidden");
          topSvg.setAttribute("hidden", "");
          sideSvg.style.display = "block";
          topSvg.style.display = "none";
        }
        q("[data-diagram-title]").textContent = nextView === "top" ? "Barrel top view" : "Barrel side section";
        updateDiagram();
      }

      function polar(cx, cy, radius, angle) {
        return [cx + radius * Math.cos(angle), cy + radius * Math.sin(angle)];
      }

      function spiralPath(innerRadius, outerRadius, turns) {
        var steps = Math.max(60, Math.round(turns * 34));
        var d = "";
        for (var i = 0; i <= steps; i += 1) {
          var t = i / steps;
          var angle = (turns * Math.PI * 2 * t) - Math.PI / 2;
          var radius = innerRadius + (outerRadius - innerRadius) * t;
          var point = polar(160, 160, radius, angle);
          d += (i === 0 ? "M " : " L ") + point[0].toFixed(2) + " " + point[1].toFixed(2);
        }
        return d;
      }

      function ringPath(cx, cy, innerRadius, outerRadius) {
        return [
          "M", cx - outerRadius, cy,
          "A", outerRadius, outerRadius, 0, 1, 0, cx + outerRadius, cy,
          "A", outerRadius, outerRadius, 0, 1, 0, cx - outerRadius, cy,
          "M", cx - innerRadius, cy,
          "A", innerRadius, innerRadius, 0, 1, 1, cx + innerRadius, cy,
          "A", innerRadius, innerRadius, 0, 1, 1, cx - innerRadius, cy
        ].join(" ");
      }

      function updateDiagram() {
        var barrelDia = numberValue("barrelDia") || 12;
        var arborDia = numberValue("arborDia") || 2.8;
        var depth = numberValue("barrelDepth") || 1.5;
        if (arborDia >= barrelDia) {
          arborDia = Math.max(0.5, barrelDia - 1);
          input("arborDia").value = arborDia.toFixed(2);
        }

        var visualScale = Math.max(0, Math.min(1, (barrelDia - 4) / 26));
        var barrelR = 72 + (visualScale * 56);
        var shellR = barrelR + 14;
        var arborR = Math.max(12, Math.min(80, (arborDia / barrelDia) * barrelR));
        var springInner = Math.min(barrelR - 18, arborR + 12);
        var springOuter = Math.max(springInner + 8, barrelR - 10);
        var turns = state.result ? Math.max(2.5, Math.min(7, (state.result.length || 250) / 75)) : Math.max(3.2, Math.min(6.8, 3.1 + (barrelDia / 6)));

        q("[data-top-shell]").setAttribute("r", shellR);
        q("[data-inner]").setAttribute("r", barrelR);
        q("[data-arbor]").setAttribute("r", arborR);
        q("[data-arbor-hatch]").setAttribute("r", arborR);
        q("[data-spring]").setAttribute("d", spiralPath(springInner, springOuter, turns));
        var fill = state.result ? Math.min(1, (state.result.fillRatio || 0) / 100) : 0;
        var fillOuter = arborR + (barrelR - arborR) * fill;
        q("[data-fill-zone]").setAttribute("d", fillOuter > arborR + 4 ? ringPath(160, 160, arborR + 3, fillOuter) : "");
        q("[data-dim-line]").setAttribute("x1", 160 - barrelR);
        q("[data-dim-line]").setAttribute("x2", 160 + barrelR);

        moveHandle("barrel-left", 160 - barrelR, 160);
        moveHandle("barrel-right", 160 + barrelR, 160);
        moveHandle("arbor-left", 160 - arborR, 160);
        moveHandle("arbor-right", 160 + arborR, 160);

        q("[data-top-barrel-label]").textContent = "Barrel: " + (numberValue("barrelDia") ? fmt(numberValue("barrelDia"), 2) + " mm" : "--");
        q("[data-top-arbor-label]").textContent = numberValue("arborDia") ? "Arbor " + fmt(numberValue("arborDia"), 2) : "Arbor";

        var sideWidth = 150 + (visualScale * 116);
        var sideX = 170 - sideWidth / 2;
        var sideInnerX = sideX + 18;
        var sideInnerW = sideWidth - 36;
        q("[data-side-shell]").setAttribute("x", sideX);
        q("[data-side-shell]").setAttribute("width", sideWidth);
        q("[data-side-inner]").setAttribute("x", sideInnerX);
        q("[data-side-inner]").setAttribute("width", sideInnerW);
        q("[data-side-spring]").setAttribute("x", sideInnerX + 16);
        q("[data-side-spring]").setAttribute("width", Math.max(40, sideInnerW - 32));

        var sideArborWidth = Math.max(18, Math.min(110, (arborDia / barrelDia) * sideInnerW));
        var sideArbor = q("[data-side-arbor]");
        sideArbor.setAttribute("x", 170 - sideArborWidth / 2);
        sideArbor.setAttribute("width", sideArborWidth);
        q("[data-side-dia-label]").textContent = "Barrel: " + (numberValue("barrelDia") ? fmt(numberValue("barrelDia"), 2) + " mm" : "--");
        q("[data-side-depth-label]").textContent = "Depth: " + (numberValue("barrelDepth") ? fmt(depth, 2) + " mm" : "--");
        q("[data-side-height-label]").textContent = "Spring height: " + (state.result ? fmt(state.result.springHeight, 2) + " mm" : "--");
        syncRangeControls();
      }

      function moveHandle(name, x, y) {
        var handle = q('[data-drag="' + name + '"] circle');
        if (!handle) return;
        handle.setAttribute("cx", x);
        handle.setAttribute("cy", y);
      }

      function getSvgX(evt) {
        var svg = q("[data-svg-top]");
        var rect = svg.getBoundingClientRect();
        var clientX = evt.touches ? evt.touches[0].clientX : evt.clientX;
        return ((clientX - rect.left) / rect.width) * 320;
      }

      function onDragStart(evt) {
        var handle = evt.target.closest("[data-drag]");
        if (!handle || !root.contains(handle)) return;
        evt.preventDefault();
        state.dragging = handle.dataset.drag;
        state.dragStartX = getSvgX(evt);
        state.dragStartValue = state.dragging.indexOf("arbor") === 0 ? (numberValue("arborDia") || 2.8) : (numberValue("barrelDia") || 12);
        document.addEventListener("mousemove", onDragMove);
        document.addEventListener("mouseup", onDragEnd);
        document.addEventListener("touchmove", onDragMove, { passive: false });
        document.addEventListener("touchend", onDragEnd);
      }

      function onDragMove(evt) {
        if (!state.dragging) return;
        evt.preventDefault();
        var dx = getSvgX(evt) - state.dragStartX;
        var barrelDia = numberValue("barrelDia") || 12;
        var pixelsPerMm = 120 / (barrelDia / 2);
        var isRight = state.dragging.indexOf("right") > -1;
        var sign = isRight ? 1 : -1;
        var next = state.dragStartValue + (sign * dx / pixelsPerMm * 2.25);

        if (state.dragging.indexOf("arbor") === 0) {
          next = Math.max(0.5, Math.min((numberValue("barrelDia") || 12) - 1, next));
          input("arborDia").value = next.toFixed(2);
        } else {
          next = Math.max(4, next);
          input("barrelDia").value = next.toFixed(2);
        }

        updateDiagram();
      }

      function onDragEnd() {
        state.dragging = null;
        document.removeEventListener("mousemove", onDragMove);
        document.removeEventListener("mouseup", onDragEnd);
        document.removeEventListener("touchmove", onDragMove);
        document.removeEventListener("touchend", onDragEnd);
      }

      function copyResults() {
        if (!state.result) return;
        var r = state.result;
        var lines = [
          "MAINSPRING SPECIFICATION - " + (root.dataset.shopName || "Shopify store"),
          "Caliber: " + (r.caliber || "Not specified"),
          "Type: " + typeLabels[r.watchType],
          "Barrel: " + fmt(r.barrelDia, 2) + " x " + fmt(r.barrelDepth, 2) + " mm",
          "Arbor: " + fmt(r.arborDia, 2) + " mm"
        ];

        if (r.mode === "calculate") {
          lines.push("Spring height: " + fmt(r.springHeight, 2) + " mm");
          lines.push("Thickness estimate: " + fmt(r.thickness, 3) + " mm");
          lines.push("Length estimate: " + Math.round(r.length) + " mm");
          lines.push("Material: " + r.material);
        } else {
          lines.push("Spring height: " + fmt(r.springHeight, 2) + " mm");
          lines.push("Thickness: " + fmt(r.thickness, 3) + " mm");
          lines.push("Length: " + Math.round(r.length) + " mm");
          lines.push("Clearance: " + fmt(r.clearance, 2) + " mm");
          lines.push("Fill ratio: " + Math.round(r.fillRatio) + "%");
        }

        lines.push("Estimates only. Verify with supplier data.");

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(lines.join("\n")).then(function () {
            toast("Copied to clipboard");
          }).catch(function () {
            toast("Copy unavailable in this browser");
          });
        } else {
          toast("Copy unavailable in this browser");
        }
      }

      function setShopLink(result) {
        var link = q("[data-shop-link]");
        if (!link || !result) return;
        var query = ["mainspring", Math.round(result.length || 0) + "mm", fmt(result.springHeight || 0, 2), fmt(result.thickness || 0, 3)].join(" ");
        var base = link.getAttribute("href").split("?")[0];
        if (base.indexOf("/search") > -1) link.href = base + "?q=" + encodeURIComponent(query);
      }

      function toast(message) {
        var box = q("[data-toast]");
        if (!box) return;
        box.textContent = message;
        box.classList.add("is-visible");
        window.clearTimeout(box._timer);
        box._timer = window.setTimeout(function () {
          box.classList.remove("is-visible");
        }, 1800);
      }

      root.addEventListener("input", function (evt) {
        if (evt.target.matches("[data-range]")) {
          var rangeName = evt.target.dataset.range;
          if (input(rangeName)) input(rangeName).value = parseFloat(evt.target.value).toFixed(2);
        }

        if (evt.target.matches("input, select")) {
          clearErrors();
          updateDiagram();
        }
      });

      root.addEventListener("click", function (evt) {
        var preset = evt.target.closest("[data-preset]");
        var mode = evt.target.closest("[data-mode]");
        var view = evt.target.closest("[data-view]");
        var action = evt.target.closest("[data-action]");

        if (preset) {
          var parts = preset.dataset.preset.split("|");
          input("caliberRef").value = parts[0];
          input("barrelDia").value = parts[1];
          input("barrelDepth").value = parts[2];
          input("arborDia").value = parts[3];
          input("watchType").value = parts[4];
          clearErrors();
          updateDiagram();
          toast("Preset applied");
        }

        if (mode) setMode(mode.dataset.mode);
        if (view) setView(view.dataset.view);

        if (action) {
          if (action.dataset.action === "calculate") {
            if (!validate()) return;
            renderResults(state.mode === "verify" ? calculateVerification() : calculateRecommendation());
          }
          if (action.dataset.action === "clear") {
            qa('input[type="number"], input[type="text"]').forEach(function (field) { field.value = ""; });
            q("[data-results]").hidden = true;
            state.result = null;
            clearErrors();
            initDefaults();
          }
          if (action.dataset.action === "copy") copyResults();
          if (action.dataset.action === "print") window.print();
        }
      });

      q("[data-svg-top]").addEventListener("mousedown", onDragStart);
      q("[data-svg-top]").addEventListener("touchstart", onDragStart, { passive: false });

      initDefaults();
      }

      function initAll(context) {
        var scope = context || document;
        var roots = [];

        if (scope.matches && scope.matches("[data-rr-ms]")) {
          roots.push(scope);
        }

        Array.prototype.slice.call(scope.querySelectorAll ? scope.querySelectorAll("[data-rr-ms]") : []).forEach(function (root) {
          if (roots.indexOf(root) === -1) roots.push(root);
        });

        roots.forEach(initMainspringCalculator);
      }

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () { initAll(document); });
      } else {
        initAll(document);
      }

      document.addEventListener("shopify:section:load", function (event) {
        initAll(event.target || document);
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-battery-finder"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function normalise(value) {
        return String(value || "").toUpperCase().replace(/[^A-Z0-9.]/g, "");
      }

      function initBatteryFinder(root) {
        if (!root || root.dataset.ready === "true") return;
        var dataNode = root.querySelector("[data-battery-data]");
        if (!dataNode) return;
        var capacitorNode = root.querySelector("[data-capacitor-data]");
        root.dataset.ready = "true";

        var batteries = [];
        var capacitors = [];
        try {
          batteries = JSON.parse(dataNode.textContent || "[]");
        } catch (error) {
          batteries = [];
        }
        try {
          capacitors = JSON.parse(capacitorNode ? capacitorNode.textContent || "[]" : "[]");
        } catch (error) {
          capacitors = [];
        }

        var state = {
          mode: "standard"
        };

        var q = function (selector) { return root.querySelector(selector); };
        var results = q("[data-results]");
        var query = q("[data-query]");
        var diameter = q("[data-diameter]");
        var height = q("[data-height]");
        var toastBox = q("[data-toast]");
        var hint = q("[data-search-hint]");
        var findLabel = q("[data-find-label]");

        function isCautionMatch(item, raw) {
          var code = normalise(raw);
          return (item.caution || []).map(normalise).indexOf(code) > -1;
        }

        function scoreBySize(item, d, h) {
          var dDiff = Math.abs(item.diameter - d);
          var hDiff = Math.abs(item.height - h);
          return dDiff + hDiff;
        }

        function findByCode(raw) {
          var code = normalise(raw);
          if (!code) return [];

          var matches = batteries.filter(function (item) {
            var codes = [item.code, item.iec].concat(item.aliases || []).map(normalise);
            return codes.indexOf(code) > -1;
          });

          if (matches.length) return matches;

          return batteries.filter(function (item) {
            var codes = [item.code, item.iec].concat(item.aliases || []).map(normalise);
            return codes.some(function (alias) {
              return alias.indexOf(code) > -1 || code.indexOf(alias) > -1;
            });
          }).slice(0, 6);
        }

        function findBySize(d, h) {
          if (!d || !h) return [];
          var source = state.mode === "capacitor" ? capacitors : batteries;
          return source
            .map(function (item) {
              return { item: item, score: scoreBySize(item, d, h) };
            })
            .filter(function (entry) {
              return Math.abs(entry.item.diameter - d) <= 0.35 && Math.abs(entry.item.height - h) <= 0.35;
            })
            .sort(function (a, b) { return a.score - b.score; })
            .slice(0, 6)
            .map(function (entry) { return entry.item; });
        }

        function findCapacitor(raw) {
          var code = normalise(raw);
          if (!code) return [];

          var exact = capacitors.filter(function (item) {
            var codes = [item.code, item.cell, item.brand].concat(item.aliases || []).concat(item.movements || []).map(normalise);
            return codes.indexOf(code) > -1;
          });

          if (exact.length) return exact;

          return capacitors.filter(function (item) {
            var codes = [item.code, item.cell, item.brand].concat(item.aliases || []).concat(item.movements || []).map(normalise);
            return codes.some(function (alias) {
              return alias.indexOf(code) > -1 || code.indexOf(alias) > -1;
            });
          }).slice(0, 6);
        }

        function safeText(text) {
          return String(text || "").replace(/[&<>"']/g, function (char) {
            return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#39;"}[char];
          });
        }

        function render(matches, raw) {
          if (!matches.length) {
            var emptyText = state.mode === "capacitor"
              ? "No close capacitor match found. Try the Seiko/Citizen part number, Casio CTL/ML code, or the movement calibre printed on the watch case back."
              : "No close match found. Check the code again, or measure the cell diameter and height in millimetres. If the old cell has leaked or the code is unreadable, compare against the movement or case back notes where possible.";
            results.innerHTML = '<div class="rr-bf__empty">' + emptyText + '</div>';
            updatePreview(null);
            return;
          }

          if (state.mode === "capacitor") {
            renderCapacitors(matches);
            return;
          }

          updatePreview(matches[0]);
          results.innerHTML = matches.map(function (item) {
            var caution = isCautionMatch(item, raw);
            var badgeClass = caution ? "rr-bf__badge rr-bf__badge--warn" : "rr-bf__badge rr-bf__badge--good";
            var badgeText = caution ? "Physical match - use silver oxide if possible" : "Best watch-cell match";
            var equivalents = [item.code, item.iec].concat(item.aliases || []).filter(function (value, index, arr) {
              return arr.map(normalise).indexOf(normalise(value)) === index;
            });

            return '<article class="rr-bf__card">' +
              '<div class="rr-bf__card-head">' +
                '<div><h3 class="rr-bf__code">' + safeText(item.code) + ' / ' + safeText(item.iec) + '</h3>' +
                '<div class="rr-bf__small">' + safeText(item.chemistry) + ' - ' + safeText(item.drain) + '</div></div>' +
                '<span class="' + badgeClass + '">' + badgeText + '</span>' +
              '</div>' +
              '<div class="rr-bf__body">' +
                '<div class="rr-bf__specs">' +
                  '<div class="rr-bf__spec"><span class="rr-bf__mini">Diameter</span><strong>' + item.diameter.toFixed(1) + ' mm</strong></div>' +
                  '<div class="rr-bf__spec"><span class="rr-bf__mini">Height</span><strong>' + item.height.toFixed(2).replace(/0$/, '') + ' mm</strong></div>' +
                  '<div class="rr-bf__spec"><span class="rr-bf__mini">Voltage</span><strong>' + safeText(item.voltage) + '</strong></div>' +
                  '<div class="rr-bf__spec"><span class="rr-bf__mini">Capacity</span><strong>' + safeText(item.capacity) + '</strong></div>' +
                '</div>' +
                '<div class="rr-bf__mini">Equivalent and related codes</div>' +
                '<div class="rr-bf__equivs">' + equivalents.map(function (code) { return '<span class="rr-bf__equiv">' + safeText(code) + '</span>'; }).join("") + '</div>' +
                '<div class="rr-bf__warning">' + safeText(item.note) + '</div>' +
                '<div class="rr-bf__actions">' +
                  '<a class="rr-bf__btn" href="' + safeText(shopLink(item)) + '">' + safeText(root.dataset.shopLinkLabel || "Shop watch batteries") + '</a>' +
                  '<button class="rr-bf__btn rr-bf__btn--ghost" type="button" data-copy="' + safeText(item.code) + '">Copy result</button>' +
                '</div>' +
              '</div>' +
            '</article>';
          }).join("");
        }

        function renderCapacitors(matches) {
          updatePreview(matches[0]);
          results.innerHTML = matches.map(function (item) {
            var codes = [item.code, item.cell].concat(item.best || []).concat(item.movements || []).filter(function (value, index, arr) {
              return arr.map(normalise).indexOf(normalise(value)) === index;
            });

            return '<article class="rr-bf__card">' +
              '<div class="rr-bf__card-head">' +
                '<div><h3 class="rr-bf__code">' + safeText(item.code) + '</h3>' +
                '<div class="rr-bf__small">' + safeText(item.brand) + ' - ' + safeText(item.type) + '</div></div>' +
                '<span class="rr-bf__badge rr-bf__badge--warn">Rechargeable cell - not a normal battery</span>' +
              '</div>' +
              '<div class="rr-bf__body">' +
                '<div class="rr-bf__specs">' +
                  '<div class="rr-bf__spec"><span class="rr-bf__mini">Cell</span><strong>' + safeText(item.cell) + '</strong></div>' +
                  '<div class="rr-bf__spec"><span class="rr-bf__mini">Diameter</span><strong>' + item.diameter.toFixed(1) + ' mm</strong></div>' +
                  '<div class="rr-bf__spec"><span class="rr-bf__mini">Height</span><strong>' + item.height.toFixed(2).replace(/0$/, '') + ' mm</strong></div>' +
                  '<div class="rr-bf__spec"><span class="rr-bf__mini">Voltage</span><strong>' + safeText(item.voltage) + '</strong></div>' +
                '</div>' +
                '<div class="rr-bf__mini">Related part numbers and calibres</div>' +
                '<div class="rr-bf__equivs">' + codes.map(function (code) { return '<span class="rr-bf__equiv">' + safeText(code) + '</span>'; }).join("") + '</div>' +
                '<div class="rr-bf__warning">' + safeText(item.note) + '</div>' +
                '<div class="rr-bf__actions">' +
                  '<a class="rr-bf__btn" href="' + safeText(capacitorShopLink(item)) + '">' + safeText(root.dataset.capacitorLinkLabel || "Shop capacitors") + '</a>' +
                  '<button class="rr-bf__btn rr-bf__btn--ghost" type="button" data-copy-cap="' + safeText(item.code) + '">Copy result</button>' +
                '</div>' +
              '</div>' +
            '</article>';
          }).join("");
        }

        function shopLink(item) {
          var link = root.dataset.shopLinkUrl || "/search";
          if (link.indexOf("/search") > -1) {
            var base = link.split("?")[0];
            return base + "?q=" + encodeURIComponent(item.code + " " + item.iec + " watch battery");
          }
          return link;
        }

        function capacitorShopLink(item) {
          var link = root.dataset.capacitorLinkUrl || "/search";
          if (link.indexOf("/search") > -1) {
            var base = link.split("?")[0];
            return base + "?q=" + encodeURIComponent(item.code + " " + item.cell + " watch capacitor");
          }
          return link;
        }

        function updatePreview(item) {
          var code = q("[data-preview-code]");
          var dia = q("[data-dia-label]");
          var h = q("[data-height-label]");
          if (!code || !dia || !h) return;

          if (!item) {
            code.textContent = "Battery";
            dia.textContent = "Diameter";
            h.textContent = "Height";
            return;
          }

          code.textContent = item.code;
          dia.textContent = item.diameter.toFixed(1) + " mm diameter";
          h.textContent = item.height.toFixed(2).replace(/0$/, "") + " mm high";
        }

        function runCodeSearch(value) {
          var raw = value || query.value;
          render(state.mode === "capacitor" ? findCapacitor(raw) : findByCode(raw), raw);
        }

        function runSizeSearch() {
          var d = parseFloat(diameter.value);
          var h = parseFloat(height.value);
          render(findBySize(d, h), "");
        }

        function setMode(nextMode) {
          state.mode = nextMode;
          root.querySelectorAll("[data-mode]").forEach(function (button) {
            button.setAttribute("aria-pressed", button.dataset.mode === nextMode ? "true" : "false");
          });
          root.querySelectorAll("[data-quick-set]").forEach(function (set) {
            set.hidden = set.dataset.quickSet !== nextMode;
          });

          if (nextMode === "capacitor") {
            query.placeholder = "Try 3023 24R, 3023 44Z, 295-56, CTL1616, 5M62, E810";
            if (hint) hint.textContent = "Search by rechargeable cell code, capacitor part number, or movement calibre.";
            if (findLabel) findLabel.textContent = "Find capacitor";
            results.innerHTML = '<div class="rr-bf__empty">Search for a solar, kinetic or Eco-Drive rechargeable cell. These are not ordinary disposable batteries; match the exact part number, connector and movement calibre before fitting.</div>';
          } else {
            query.placeholder = "Try 377, SR626SW, AG4, LR44, 6.8 x 2.6";
            if (hint) hint.textContent = "Enter a code from the old cell, or measure diameter x height in mm.";
            if (findLabel) findLabel.textContent = "Find battery";
            results.innerHTML = '<div class="rr-bf__empty">Search for a code such as <strong>377</strong>, <strong>SR626SW</strong>, <strong>AG4</strong> or enter a measured size. Silver oxide watch cells are normally the best choice for watches; alkaline AG/LR numbers are shown with caution where relevant.</div>';
          }
          query.value = "";
          diameter.value = "";
          height.value = "";
          updatePreview(null);
        }

        function toast(message) {
          if (!toastBox) return;
          toastBox.textContent = message;
          toastBox.classList.add("is-visible");
          window.clearTimeout(toastBox._timer);
          toastBox._timer = window.setTimeout(function () {
            toastBox.classList.remove("is-visible");
          }, 1800);
        }

        root.addEventListener("click", function (event) {
          var action = event.target.closest("[data-action]");
          var code = event.target.closest("[data-code]");
          var copy = event.target.closest("[data-copy]");
          var copyCap = event.target.closest("[data-copy-cap]");
          var mode = event.target.closest("[data-mode]");

          if (mode) setMode(mode.dataset.mode);

          if (code) {
            query.value = code.dataset.code;
            runCodeSearch(code.dataset.code);
          }

          if (action && action.dataset.action === "find") runCodeSearch();
          if (action && action.dataset.action === "size") runSizeSearch();

          if (copy) {
            var match = findByCode(copy.dataset.copy)[0];
            if (!match) return;
            var text = match.code + " / " + match.iec + " - " + match.diameter + " x " + match.height + "mm - " + match.chemistry;
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(text).then(function () { toast("Copied"); });
            } else {
              toast("Copy unavailable");
            }
          }

          if (copyCap) {
            var cap = findCapacitor(copyCap.dataset.copyCap)[0];
            if (!cap) return;
            var capText = cap.code + " - " + cap.brand + " - " + cap.cell + " - " + cap.voltage;
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(capText).then(function () { toast("Copied"); });
            } else {
              toast("Copy unavailable");
            }
          }
        });

        root.addEventListener("keydown", function (event) {
          if (event.key === "Enter" && event.target === query) {
            event.preventDefault();
            runCodeSearch();
          }
        });
      }

      function initAll(context) {
        var scope = context || document;
        var roots = [];
        if (scope.matches && scope.matches("[data-rr-bf]")) roots.push(scope);
        Array.prototype.slice.call(scope.querySelectorAll ? scope.querySelectorAll("[data-rr-bf]") : []).forEach(function (root) {
          if (roots.indexOf(root) === -1) roots.push(root);
        });
        roots.forEach(initBatteryFinder);
      }

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", function () { initAll(document); });
      } else {
        initAll(document);
      }

      document.addEventListener("shopify:section:load", function (event) {
        initAll(event.target || document);
      });
    })();
  
  } catch(e) { console.error(e); }
})();
})();
